<footer class="footer">
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <img src="assets/img/taskradar.png" alt="TaskRadar Logo" height="40" class="mb-3">
        <p>TaskRadar - Ihre komplette Aufgabenverwaltungslösung für gesteigerte Produktivität.</p>
      </div>
      <div class="col-md-6 text-end">
        <h5>Schnelllinks</h5>
        <p>
          <a routerLink="/terms">Nutzungsbedingungen</a> |
          <a routerLink="/imprint">Impressum</a> |
          <a routerLink="/login">Anmelden</a>
        </p>
        <p class="mt-3">&copy; {{currentYear}} TaskRadar. Alle Rechte vorbehalten.</p>
      </div>
    </div>
  </div>
</footer>
